  function toIsoDate(input, pivot = 50) {
    // split on slash, expect exactly 3 parts
    const parts = input?.split('/');
    if (parts?.length !== 3) {
      return null;
    }
  
    let [mm, dd, yy] = parts.map(s => s.trim());
    if (!/^\d{1,2}$/.test(mm) || !/^\d{1,2}$/.test(dd) || !/^\d{2,4}$/.test(yy)) {
      return null;
    }
  
    // normalize year
    let yearNum = parseInt(yy, 10);
    if (yy.length === 2) {
      yearNum += yearNum < pivot ? 2000 : 1900;
    }
    const monthNum = parseInt(mm, 10);
    const dayNum   = parseInt(dd, 10);
  
    // validate via Date object
    const dt = new Date(Date.UTC(yearNum, monthNum - 1, dayNum));
    if (
      dt.getUTCFullYear() !== yearNum ||
      dt.getUTCMonth()    !== monthNum - 1 ||
      dt.getUTCDate()     !== dayNum
    ) {
      return null;
    }
  
    // format to YYYY-MM-DD
    const YYYY = dt.getUTCFullYear();
    const MM   = String(monthNum).padStart(2, '0');
    const DD   = String(dayNum).padStart(2, '0');
  
    return `${YYYY}-${MM}-${DD}`;
  }

  function fromIsoToShort(input) {
    const dt = new Date(input+ 'T00:00:00Z');
    if (Number.isNaN(dt.getTime())) return null;
    // en-US gives M/D/YY by default, so we force two-digit parts:
    return dt.toLocaleDateString('en-US', {
      year:  '2-digit',
      month: '2-digit',
      day:   '2-digit',
      timeZone: 'UTC'
    });
  }


  export {
    toIsoDate,
    fromIsoToShort
}
